import styled from 'styled-components';

const IntroProductsFeatureItemsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    height: 40vh;
`;

export default IntroProductsFeatureItemsContainer;
